export const regionKeys = {
  regions: () => ['REGIONS'] as const,
};
